import { createContext } from 'react';
export var Context = createContext({
    prefix: 'aidb',
});
